import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  containerBase: {
    padding: '0 0.5rem',
    display: 'flex',
    flexDirection: 'row',
    gap: '3rem',
  },

  containerInfo: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  },

  groupText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0rem',

    '& span': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#191C1A',
      padding: 0,
      margin: 0,
    },
  },

  title: {
    fontFamily: 'Nunito',
    fontWeight: '400 !important',
    fontSize: '0.75rem !important',
    lineHeight: '1.25rem !important',
    color: '#8B8D97',
  },

  subTitle: {
    fontFamily: 'Nunito',
    fontWeight: '400 !important',
    fontSize: '0.75rem !important',
    lineHeight: '1.25rem !important',
    color: `${getRGBA('#0F0F1E', 0.6)}  !important`,
  },

  content: {
    fontFamily: 'Sora',
    fontWeight: '400 !important',
    fontSize: '1.25rem !important',
    lineHeight: '2rem !important',
    color: '#191C1A !important',
    marginTop: '0.35rem !important',
  },
}))

export { useStyles }
